<ion-header>
  <ion-toolbar>
    <ion-title>Public Profile QR Code</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="modalGC.dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="qr-code-container">
    <div class="qr-code-wrapper" #qrCodeWrapper>
      <qrcode [qrdata]="profileUrl" [width]="256" [margin]="1" elementType="img"></qrcode>
    </div>
    
    <div class="buttons-container">
      <ion-button 
        expand="block" 
        mode="ios" 
        color="primary" 
        (click)="downloadQRCode()"
        data-cy="download-qr-code-button">
        <ion-icon name="download-outline" slot="start"></ion-icon>
        Download QR Code
      </ion-button>
      
      <ion-button 
        expand="block" 
        mode="ios" 
        color="gc-green" 
        (click)="openLink()"
        data-cy="open-link-button">
        <ion-icon name="globe-outline" slot="start"></ion-icon>
        Open Link
      </ion-button>
    </div>
  </div>
</ion-content>

